
export default function useDevice () {
  let size = {
    isH5: false, // APP内||本地||(url中存在isTestH5参数&&测试环境) || 0-824
    isInApp: false, // 是否在管理app打开
    isMobile: false, // 0-824 尺寸是否为H5
    isPad: false, // 824-1280
    isSmPc: false, // 1280-1290
    isLgPc: false, // 1290-∞
  }

  return size
}
